var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHomeVirtualStockIconCard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 72,
    viewBox: "0 0 73 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.5 72C56.3822 72 72.5 55.8823 72.5 36C72.5 16.1178 56.3822 0 36.5 0C16.6177 0 0.5 16.1178 0.5 36C0.5 55.8823 16.6177 72 36.5 72Z",
    fill: "#F2C94C",
    fillOpacity: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.0241 21.3911H29.7938C28.4245 21.3911 27.3145 22.5011 27.3145 23.8704V23.8704C27.3145 25.2397 28.4245 26.3498 29.7938 26.3498H48.0241C49.3934 26.3498 50.5035 25.2397 50.5035 23.8704C50.5035 22.5011 49.3934 21.3911 48.0241 21.3911Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0169 31.3087H59.8011C61.1704 31.3087 62.2804 32.4188 62.2804 33.7881C62.2804 35.1574 61.1704 36.2674 59.8011 36.2674H18.0169C16.6476 36.2674 15.5376 35.1574 15.5376 33.7881C15.5376 32.4188 16.6476 31.3087 18.0169 31.3087V31.3087Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0169 41.2262H59.8011C61.1704 41.2262 62.2804 42.3362 62.2804 43.7055C62.2804 45.0749 61.1704 46.1849 59.8011 46.1849H18.0169C16.6476 46.1849 15.5376 45.0749 15.5376 43.7055C15.5376 42.3362 16.6476 41.2262 18.0169 41.2262V41.2262Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6432 35.4395C23.6148 35.4404 23.5864 35.441 23.558 35.4418C23.5458 35.4734 23.5327 35.5047 23.5176 35.5354L23.6432 35.4395V35.4395Z",
    fill: "#404040"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M64.5816 38.2466C65.8636 22.7562 54.3454 9.15945 38.855 7.87742C23.3645 6.59539 9.76777 18.1136 8.48574 33.604C7.20372 49.0944 18.7219 62.6912 34.2123 63.9732C49.7028 65.2553 63.2996 53.7371 64.5816 38.2466Z",
    fill: "#F2C94C"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M43.7031 46.2852H50.2141V37.9355",
    stroke: "white",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M45.8735 42.1108L35.5644 28.8906L30.1386 35.8486L21.9999 25.4116",
    stroke: "white",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeVirtualStockIconCard);
export default __webpack_public_path__ + "static/media/homeVirtualStockIconCard.6e5c67c94ba4a739f8aab1cd014b3f4b.svg";
export { ForwardRef as ReactComponent };